import React, { ReactNode } from 'react';
import s from './SeoContent.module.scss';

const SeoContent = (props: { children: ReactNode }) => {
	const { children } = props;
	return (
		<React.Fragment>
			{/* <div className={s.grayBorder} /> */}
			<div className={s.seoContent}>{children}</div>
		</React.Fragment>
	);
};

export default SeoContent;
